import { take, fork, all } from 'redux-saga/effects';
import { apiTask, watchApiTask } from '../../app/sagas';
import { api } from '../../app/api';
import * as actions from './simulatedQuestionsActions';

export const approveQuestionTask = watchApiTask(
  actions.APPROVE_QUESTION,
  api.post,
  '/evaluation-system/approveQuestion.php',
);

export const reproveQuestionTask = watchApiTask(
  actions.REPROVE_QUESTION,
  api.post,
  '/evaluation-system/disapproveQuestion.php',
);

export const approveEvaluationTask = watchApiTask(
  actions.APPROVE_EVALUATION,
  api.post,
  '/evaluation-system/approveEvaluationQuestions.php',
);

export const getQuestionTask = watchApiTask(
  actions.GET_QUESTION,
  api.post,
  '/evaluation-system/getQuestions.php',
);

export const getEvaluationTask = watchApiTask(
  actions.GET_EVALUATION,
  api.post,
  '/evaluation-system/getEvaluationInformation.php',
);

export const getQuestionsTask = watchApiTask(
  actions.GET_QUESTIONS,
  api.post,
  '/evaluation-system/getQuestions.php',
);

// Root module saga
export function* sagas() {
  yield all([
    fork(getEvaluationTask),
    fork(getQuestionTask),
    fork(getQuestionsTask),
    fork(approveEvaluationTask),
    fork(approveQuestionTask),
    fork(reproveQuestionTask),
  ]);
}
